export const mapBackendToForm = (data, uhid_no) => {
  if (!data) return {};

  const existingData = {
    uhid_no: data.uhid_no || uhid_no,
    preinduction_pulse: data.preinduction_pulse || "",
    preinduction_bp: data.preinduction_bp || "",
    preinduction_others: data.preinduction_others || "",
    preinduction_sign_name: data.preinduction_sign_name || "",
    preinduction_sign_datetime: data.preinduction_sign_datetime || "",
    signature: data.signature || "",
    anaesthetist1: data.anaesthetist1 || "",
    anaesthetist2: data.anaesthetist2 || "",
    surgeon1: data.surgeon1 || "",
    surgeon2: data.surgeon2 || "",
    oral_nasal: data.oral_nasal || "",
    cuffed: data.cuffed || "",
    tube_size_label: data.tube_size_label || "",
    scope_grade: data.scope_grade || "",
    in_out: data.in_out || "",
    induction_iv_access: data.induction_iv_access || "",
    induction_pre_oxygenation: data.induction_pre_oxygenation || "",
    induction_rapid_sequence: data.induction_rapid_sequence || "",
    induction_inhalational_agent: data.induction_inhalational_agent || "",
    induction_throat_pack: data.induction_throat_pack || "",
    monitoring_spo2: data.monitoring_spo2,
    monitoring_ecg: data.monitoring_ecg,
    monitoring_nibp: data.monitoring_nibp,
    monitoring_etco2: data.monitoring_etco2,
    monitoring_fio2: data.monitoring_fio2,
    monitoring_temp: data.monitoring_temp,
    monitoring_cvp: data.monitoring_cvp,
    monitoring_arterial_line: data.monitoring_arterial_line,
    monitoring_uop: data.monitoring_uop,
    equipment_checked: data.equipment_checked,
    consent_checked: data.consent_checked,
    drug_inputs: data.drug_inputs || '["","","","","","","",""]',
    gas_n2o: data.gas_n2o || "",
    gas_oxygen_f1fe: data.gas_oxygen_f1fe || "",
    gas_vapour_f1fe: data.gas_vapour_f1fe || "",
    ecg_position: data.ecg_position || "",
    temperature_reading: data.temperature_reading || "",
    fm_iv_fluid: data.fm_iv_fluid || "",
    fm_blood_loss: data.fm_blood_loss || "",
    fm_urine_output: data.fm_urine_output || "",
    fm_tourniquet: data.fm_tourniquet || "",
    proc_drug_reversal: data.proc_drug_reversal,
    proc_post_operative: data.proc_post_operative,
    proc_post_op_ward: data.proc_post_op_ward,
    proc_delayed_recovery: data.proc_delayed_recovery,
    proc_drug_reaction: data.proc_drug_reaction,
    proc_aspiration: data.proc_aspiration,
    proc_cardiac_arrest: data.proc_cardiac_arrest,
    proc_others: data.proc_others,
    drug_chart_data: data.drug_chart_data || "",
    primary_monitoring_data: data.primary_monitoring_data || "",
    advanced_monitoring_data: data.advanced_monitoring_data || "",
    clinical_notes: data.clinical_notes || "",
  };

  let formattedDate = existingData.preinduction_sign_datetime;
  if(formattedDate && !formattedDate.includes("T")) {
    // try to convert array format to local string
    try{
      let date = new Date(formattedDate);
       formattedDate = date.toISOString().slice(0, 16);
    } catch(err){
      // pass
    }
  }

  let drugInputsParsed = ["","","","","","","",""];
  try{
    drugInputsParsed = JSON.parse(existingData.drug_inputs);
  } catch(e) {}

  return {
    uhid_no: existingData.uhid_no,
    pulse: existingData.preinduction_pulse,
    bp: existingData.preinduction_bp,
    others: existingData.preinduction_others,
    signName: existingData.preinduction_sign_name,
    signDateTime: formattedDate,
    signature: existingData.signature,
    anaesthetist1: existingData.anaesthetist1,
    anaesthetist2: existingData.anaesthetist2,
    surgeon1: existingData.surgeon1,
    surgeon2: existingData.surgeon2,
    oralNasal: existingData.oral_nasal,
    cuffed: existingData.cuffed,
    size: existingData.tube_size_label,
    scopeGrade: existingData.scope_grade,
    inOut: existingData.in_out,
    ivAccess: existingData.induction_iv_access,
    preOxygenation: existingData.induction_pre_oxygenation,
    rapidSequence: existingData.induction_rapid_sequence,
    inhalationalAgent: existingData.induction_inhalational_agent,
    throatPack: existingData.induction_throat_pack,
    monitoring: {
      spo2: Boolean(existingData.monitoring_spo2),
      ecg: Boolean(existingData.monitoring_ecg),
      nibp: Boolean(existingData.monitoring_nibp),
      etco2: Boolean(existingData.monitoring_etco2),
      fio2: Boolean(existingData.monitoring_fio2),
      temp: Boolean(existingData.monitoring_temp),
      cvp: Boolean(existingData.monitoring_cvp),
      arterialLine: Boolean(existingData.monitoring_arterial_line),
      uop: Boolean(existingData.monitoring_uop),
    },
    equipmentChecked: Boolean(existingData.equipment_checked),
    consentChecked: Boolean(existingData.consent_checked),
    drugInputs: drugInputsParsed,
    n2o: existingData.gas_n2o,
    oxygenF1Fe: existingData.gas_oxygen_f1fe,
    vapourF1Fe: existingData.gas_vapour_f1fe,
    ecgPosition: existingData.ecg_position,
    temperatureReading: existingData.temperature_reading,
    ivFluid: existingData.fm_iv_fluid,
    bloodLoss: existingData.fm_blood_loss,
    urineOutput: existingData.fm_urine_output,
    tourniquet: existingData.fm_tourniquet,
    procedures: {
      drugReversal: Boolean(existingData.proc_drug_reversal),
      postOperative: Boolean(existingData.proc_post_operative),
      postOpWard: Boolean(existingData.proc_post_op_ward),
      delayedRecovery: Boolean(existingData.proc_delayed_recovery),
      drugReaction: Boolean(existingData.proc_drug_reaction),
      aspiration: Boolean(existingData.proc_aspiration),
      cardiacArrest: Boolean(existingData.proc_cardiac_arrest),
      others: Boolean(existingData.proc_others),
    },
    clinicalNotes: existingData.clinical_notes,
    drugChartData: existingData.drug_chart_data,
    primaryMonitoringData: existingData.primary_monitoring_data,
    advancedMonitoringData: existingData.advanced_monitoring_data,
  };
};

export const mapFormToBackend = (formData, gridData) => {
  return {
    uhid_no: formData.uhid_no,
    preinduction_pulse: formData.pulse,
    preinduction_bp: formData.bp,
    preinduction_others: formData.others,
    preinduction_sign_name: formData.signName,
    preinduction_sign_datetime: formData.signDateTime,
    signature: formData.signature, // This seems to still need base64 cleanup if using standard canvas! However, I will leave it as it was in original
    anaesthetist1: formData.anaesthetist1,
    anaesthetist2: formData.anaesthetist2,
    surgeon1: formData.surgeon1,
    surgeon2: formData.surgeon2,
    oral_nasal: formData.oralNasal,
    cuffed: formData.cuffed,
    tube_size_label: formData.size,
    scope_grade: formData.scopeGrade,
    in_out: formData.inOut,
    induction_iv_access: formData.ivAccess,
    induction_pre_oxygenation: formData.preOxygenation,
    induction_rapid_sequence: formData.rapidSequence,
    induction_inhalational_agent: formData.inhalationalAgent,
    induction_throat_pack: formData.throatPack,
    monitoring_spo2: formData.monitoring.spo2,
    monitoring_ecg: formData.monitoring.ecg,
    monitoring_nibp: formData.monitoring.nibp,
    monitoring_etco2: formData.monitoring.etco2,
    monitoring_fio2: formData.monitoring.fio2,
    monitoring_temp: formData.monitoring.temp,
    monitoring_cvp: formData.monitoring.cvp,
    monitoring_arterial_line: formData.monitoring.arterialLine,
    monitoring_uop: formData.monitoring.uop,
    equipment_checked: formData.equipmentChecked,
    consent_checked: formData.consentChecked,
    drug_inputs: JSON.stringify(formData.drugInputs),
    gas_n2o: formData.n2o,
    gas_oxygen_f1fe: formData.oxygenF1Fe,
    gas_vapour_f1fe: formData.vapourF1Fe,
    ecg_position: formData.ecgPosition,
    temperature_reading: formData.temperatureReading,
    fm_iv_fluid: formData.ivFluid,
    fm_blood_loss: formData.bloodLoss,
    fm_urine_output: formData.urineOutput,
    fm_tourniquet: formData.tourniquet,
    proc_drug_reversal: formData.procedures.drugReversal,
    proc_post_operative: formData.procedures.postOperative,
    proc_post_op_ward: formData.procedures.postOpWard,
    proc_delayed_recovery: formData.procedures.delayedRecovery,
    proc_drug_reaction: formData.procedures.drugReaction,
    proc_aspiration: formData.procedures.aspiration,
    proc_cardiac_arrest: formData.procedures.cardiacArrest,
    proc_others: formData.procedures.others,
    clinical_notes: formData.clinicalNotes,
    drug_chart_data: gridData.drugChartData,
    primary_monitoring_data: gridData.primaryMonitoringData,
    advanced_monitoring_data: gridData.advancedMonitoringData,
  };
};
